import $ from 'jquery';
import _ from 'lodash';
import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./genericfilters-widget.html';
import QueryCommon from '../../../app/helpers/query-common';
import DataRepository from '../../../app/data-framework/data-repository';
import DataProvider from '../../../app/data-framework/data-provider';
import Signals from 'signals';


function GenericFiltersWidget(params) {
    var self = this;

    self.queryCommon = new QueryCommon();
    self.dataRepository = DataRepository.getInstance();
    self.DataProvider = DataProvider.getInstance();

    self.observableOptions = params.observableOptions;
    self.observableData = params.observableData;
    self.panelTemplate = params.panelTemplate;
    self.widgetSignals = params.widgetSignals;
    self.viewLevelOptions = params.viewLevelOptions;
    self.columnOptionsObs = ko.observableArray();
    self.visibilityOptions = params.visibilityOptions;
    self.typeaheadDisplayMode = params.typeaheadDisplayMode;

    self.widgetSignals().enableApply = new Signals.Signal();

    self.flexQueryViewLevelOptions = ko.observable({
        WhereConditionObj: self.viewLevelOptions() ? self.viewLevelOptions().WhereConditionObj : [],
        WhereConditionConjunction: self.viewLevelOptions() ?  self.viewLevelOptions().WhereConditionConjunction : 'and'
    });

    self.subscriptions = [];
    self.endpointModels = new ko.observableArray();
    self.systems = new ko.observableArray();

    self.setMode = false;

    if (params.columnOptionsObs && params.columnOptionsObs()) {
        self.setMode = true;

        // todo remove endpointModelsObs
        var endpointModelsObs = params.endpointModelsObs;

        if (endpointModelsObs && ko.isObservable(endpointModelsObs)) {
            if (!_.isEmpty(ko.unwrap(endpointModelsObs))) {
                self.endpointModels(getModelsTree(endpointModelsObs()));
            } else {
                var sub = endpointModelsObs.subscribe(function (endpointModels) {
                    if (endpointModels) {
                        self.endpointModels(getModelsTree(endpointModels));
                        sub.dispose();
                    }
                });
            }
        }

        // todo remove systemsObs
        var systemsObs = params.systemsObs;

        if (systemsObs && ko.isObservable(systemsObs)) {
            if (!_.isEmpty(ko.unwrap(systemsObs))) {
                var categoryKey = ko.unwrap(params.selectedCategory) || "*";
                var systemsDict = ko.unwrap(systemsObs);

                if (!_.has(systemsDict, categoryKey)) {
                    self.DataProvider.loadSystems(categoryKey);
                } else {
                    self.systems(getSystemsTree(_.get(systemsDict, categoryKey)));
                }
            } else {
                var subSystems = systemsObs.subscribe(function (systems) {
                    if (systems) {
                        self.systems(getSystemsTree(systems));
                        subSystems.dispose();
                    }
                });
            }
        }

        self.columnOptionsObs = params.columnOptionsObs;
        self.columnOptionsObs.valueHasMutated();

        self.setMode = false;

        self.getFilterData();
    }
    else {
        self.subscriptions.push(self.observableData.subscribe(function () {
            self.DataUpdated();
        }));
        self.RefreshData();
    }

    if (params.selectedCategory && ko.isObservable(params.selectedCategory)) {
        self.subscriptions.push(params.selectedCategory.subscribe(function(category) {
            if (!category) {
                return;
            }

            var systemsDict = self.dataRepository.systemsDictionary();

            if (_.isEmpty(_.get(systemsDict, category))) {
                self.DataProvider.loadSystems(category);
            }
            else {
                self.systems(getSystemsTree(_.get(systemsDict, category)));
            }
        }));

        self.subscriptions.push(self.dataRepository.systemsDictionary.subscribe(function(systemsDict) {
            var category = params.selectedCategory();

            if (category && systemsDict[category]) {
                self.systems(getSystemsTree(systemsDict[category]));
            }
        }));
    }

    self.subscriptions.push(self.flexQueryViewLevelOptions.subscribe(self.setViewLevelOptions, self));
    self.subscriptions.push(self.viewLevelOptions.subscribe(function () {
        self.getFilterData();
    }));
}

function getSystemsTree(systemsList) {
    if (_.isEmpty(systemsList)) {
        return [];
    }

    return treeifyList(systemsList, "dimsystem.systemCategory", "dimsystem.systemtype", "dimsystem.name");
}

function getModelsTree(modelsList) {
    if (_.isEmpty(modelsList)) {
        return [];
    }

    return treeifyList(modelsList, "dimendpoint.endpointsubcategory", "dimendpoint.model");
}

//although this function belongs in the formatter, it is here because this widget is used directly by flexipanel-options
function treeifyList(list, toplevelcolumn, secondlevelcolumn, thirdlevelcolumn) {
    var topLevelGroup = groupBy(list, toplevelcolumn, secondlevelcolumn);
    var mappedItems = [];

    for (var item in topLevelGroup) {
        var mappedParents = [];

        if (thirdlevelcolumn && topLevelGroup[item] && topLevelGroup[item].length) {
            var listFilteredOnTopLevel = _.filter(list, [toplevelcolumn, item]);
            var groupedParents = groupBy(listFilteredOnTopLevel, secondlevelcolumn, thirdlevelcolumn);

            for (var parent in groupedParents) {
                mappedParents.push({
                    text: parent,
                    state: {
                        opened: false
                    },
                    icon: false,
                    children: groupedParents[parent].sort(compareText)
                });
            }
        }

        mappedItems.push({
            text: item,
            state: {
                opened: false
            },
            icon: false,
            children: thirdlevelcolumn ? mappedParents.sort(compareText) : topLevelGroup[item].sort(compareText)
        });
    }
    return mappedItems.sort(compareText);
}

function compareText( a, b ) {
  if ( a.text < b.text ){
    return -1;
  }
  if ( a.text > b.text ){
    return 1;
  }
  return 0;
}

function groupBy(items, parentKey, childKey) {
    return _.reduce(items, function (acc, item) {
        (acc[item[parentKey]] = acc[item[parentKey]] || []).push({
            text: item[childKey],
            state: {
                opened: true,
                selected: false
            },
            icon: false,
        });
        return acc;
    }, {});
}

GenericFiltersWidget.prototype = {
    setViewLevelOptions: function() {
        var self = this;

        if (self.setMode) {
            return;
        }

        self.setMode = true;
        var updatedCondition = self.flexQueryViewLevelOptions();

        self.viewLevelOptions(updatedCondition);

        // legacy options
        if (_.isArray(self.flexQueryViewLevelOptions())) {
            self.flexQueryViewLevelOptions({
                WhereConditionObj: self.flexQueryViewLevelOptions().WhereConditionObj,
                WhereConditionConjunction: self.flexQueryViewLevelOptions().WhereConditionConjunction
            });
        }
        self.setMode = false;
    },

    getFilterData: function () {
        var self = this;

        if (self.setMode) {
            return;
        }
        if (!self.viewLevelOptions || !self.viewLevelOptions()) {
            return;
        }

        self.setMode = true;
        let flexQueryVlo = {};
        let vlo = ko.unwrap(self.viewLevelOptions);

        if (vlo.WhereConditionConjunction) {
            flexQueryVlo.WhereConditionConjunction = vlo.WhereConditionConjunction;
        }

        if (vlo.WhereConditionObj) {
            flexQueryVlo.WhereConditionObj = vlo.WhereConditionObj;
            self.flexQueryViewLevelOptions(flexQueryVlo);
        }
        else if (vlo.WhereCondition) {
            var legacyValues = self.queryCommon.parseConditions(self.viewLevelOptions, []);

            self.flexQueryViewLevelOptions({
                WhereConditionObj: legacyValues.flexQueryWhereConditionObj
            });
        }
        self.setMode = false;
    },

    RefreshData: function () {
        var self = this;
        var data = ko.unwrap(self.observableData);

        if (!_.isEmpty(data)) {
            self.setMode = true;

            if (!_.isEmpty(data.endpointModels)) {
                self.endpointModels(getModelsTree(data.endpointModels));
            }
            if (!_.isEmpty(data.systems)) {
                self.systems(getSystemsTree(data.systems));
            }
            if (!_.isEmpty(data.columnOptions)) {
                self.columnOptionsObs(data.columnOptions);
            }

            self.setMode = false;
            self.getFilterData();
        }
    },

    DataUpdated: function () {
        var self = this;
        self.RefreshData();
    },

    dispose: function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
        if (self.viewLevelOptions && self.viewLevelOptions()) {
            let vlo = self.viewLevelOptions();
            delete vlo.WhereConditionConjunction;
            delete vlo.WhereConditionObj;
            delete vlo.WhereCondition;
            self.viewLevelOptions(vlo);
        }
    }
};


export default {
    viewModel: GenericFiltersWidget,
    template: templateMarkup
};
